// Utils
import isMatchFilter from '../../../utils/isMatchFilter';
import isActiveAndAvailable from './filtersAvailability';
import matchAvailableFilter from './matchAvailableFilter';

const applyProductFilters = (product, filters, frequentlyOrdered) => {
  if (!isActiveAndAvailable(product, filters)) {
    return false;
  }

  const isMatchFavourite = filters.favorites ? product.is_favourite : true;
  const isMatchFrequentlyOrdered = filters.frequentlyOrdered
    ? frequentlyOrdered.some((item) => item.product === product.product_id)
    : true;

  return (
    isMatchFavourite &&
    isMatchFilter(product, filters, 'brand_category') &&
    isMatchFilter(product, filters, 'owner') &&
    isMatchFilter(product, filters, 'audience') &&
    isMatchFilter(product, filters, 'indication') &&
    matchAvailableFilter(product, filters.available) &&
    isMatchFrequentlyOrdered
  );
};

export default applyProductFilters;
